import styled from 'styled-components';

export const NavItem = styled.div<{ isActive: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 0.25rem;
    color: ${({ isActive }) => (isActive ? '#fff' : '#a6a6a6')};
    transition: color 0.2s ease;
    cursor: pointer;

    &.active {
        color: #fff;

        .iconWrapper::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 50px;
            height: 50px;
            background: radial-gradient(
                circle,
                rgba(34, 197, 94, 0.4) 0%,
                rgba(34, 197, 94, 0.2) 50%,
                rgba(34, 197, 94, 0.05) 80%,
                transparent 100%
            );
            border-radius: 50%;
            filter: blur(8px);
            z-index: -1;
        }
    }
`;

export const IconWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: auto;
`;

export const Label = styled.span`
    font-size: 0.625rem;
    text-align: center;
    line-height: 1rem;
`;
